export default __webpack_public_path__ + "static/media/truck_color.5c195cbd.svg";